import { render, staticRenderFns } from "./PublishedList.vue?vue&type=template&id=c9c64280&scoped=true&"
import script from "./PublishedList.vue?vue&type=script&lang=js&"
export * from "./PublishedList.vue?vue&type=script&lang=js&"
import style0 from "./PublishedList.vue?vue&type=style&index=0&id=c9c64280&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c64280",
  null
  
)

export default component.exports